import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { NationalStockAllPageRoutingModule } from "./national-stock-all-routing.module";
import { NationalStockAllPage } from "./national-stock-all.page";
import { IonicSelectableModule } from "ionic-selectable";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    NationalStockAllPageRoutingModule,
    IonicSelectableModule,
  ],
  declarations: [NationalStockAllPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NationalStockAllPageModule {}
